import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PaymentPromo from '../components/promo/payment/';

const PromoPage = ({user}) => {

	if(user.loading){
		return <div>Loading...</div>;
	}

	if( user.data.permissions && !user.data.permissions.ezSuperuser){
		return <Redirect to="/" />
	}

	return <div style={{padding:8}}>
		<PaymentPromo />
	</div>
}

export default connect(
	state => ({
		user: state.user
	})
)(PromoPage);


// WEBPACK FOOTER //
// ./src/containers/promo-page.js